export default __webpack_public_path__ + "static/media/gift1.85a6d7d8.png";